// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { MdSortByAlpha, MdWhatshot } from 'react-icons/md';

import cx from 'classnames';
import './TagsTab.scss';

type Props = {
  sort: ?string,
};

const TagsTab = ({ sort }: Props) => (
  <div className="TagsTab">
    <Link className={cx({ active: sort === 'popular' })} to="/tags?sort=popular">
      <MdWhatshot />
      인기순
    </Link>
    <Link className={cx({ active: sort === 'name' })} to="/tags?sort=name">
      <MdSortByAlpha />
      이름순
    </Link>
  </div>
);

TagsTab.defaultProps = {
  sort: 'popular',
};

export default TagsTab;



// WEBPACK FOOTER //
// ./src/components/tags/TagsTab/TagsTab.js